import React from 'react';

import { ITableModel } from 'components/Table/interface';
import Text from 'components/Text';
import { StatusFlowEnum } from './interface';

import { StatusFlowWrapper } from './styles';

const labelBuyOrder = {
  label: 'Ordem de Compra',
  key: 'buyOrder',
  size: 90,
  maxSize: 90,
  noFilter: true
};

const labelOrder = {
  label: 'Pedido',
  key: 'orderSale',
  size: 80,
  maxSize: 80,
  noFilter: true
};

const labelInvoice = {
  label: 'Nota Fiscal',
  key: 'invoiceNumber',
  size: 105,
  maxSize: 105,
  noFilter: true
};

const labelItems = {
  label: 'Itens',
  key: 'orderItemsQuantity',
  size: 80,
  maxSize: 80,
  noFilter: true
};

const labelDocumentNumber = {
  label: 'CNPJ',
  key: 'documentNumber',
  type: "cnpj",
  size: 150,
  maxSize: 150,
  noFilter: true
};

const labelCompanyName = {
  label: 'Cliente',
  key: 'companyName',
  size: 220,
  maxSize: 220,
  noFilter: true
};

const labelEnterpriseName = {
  label: 'Empresa',
  key: 'enterpriseName',
  size: 100,
  maxSize: 100
};

const labelOrderValue = {
  label: 'Valor',
  key: 'totalOrderValue',
  type: 'currency',
  size: 120,
  maxSize: 120,
  noFilter: true
};

const labelIntegrationDate = {
  label: 'Data da Integração',
  key: 'integrationUpdatedDate',
  type: 'date/hour',
  size: 150,
  maxSize: 150,
  noFilter: true,
};


const labelStatusFlow = {
  label: 'Situação',
  key: 'statusFlow',
  size: 200,
  noFilter: true,
  Component: (data: any) => (
    <>
      <StatusFlowWrapper variant={data.statusFlow} />
      <Text className="color-blue-gray first-letter-uppercase" size={12} showTip>
        {StatusFlowEnum[data.statusFlow as keyof typeof StatusFlowEnum]}
      </Text>
    </>
  )
};

const dataIntegrationModel: Array<ITableModel> = [
  labelBuyOrder,
  labelOrder,
  labelInvoice,
  labelItems,
  labelDocumentNumber,
  labelCompanyName,
  labelEnterpriseName,
  labelOrderValue,
  labelIntegrationDate,
  labelStatusFlow
];

const modelDataIntegration = () => {
  const model: Array<ITableModel> = [
    ...dataIntegrationModel
  ];

  return model;
};

export {
  modelDataIntegration
};